<i18n src="@/locales/modules/RequestTranslate.json"></i18n>

<template>
	<div class="list-requests-dashboard cbs-custom-table pb-3">
		<div class="header">
			<h4 class="header__title pt-6 pl-6">{{ $t("WaitingList") }}</h4>
		</div>

		<request-table
			class="p-6"
			:isQuickMode="true"
			:data="requestsMixin"
			@onClickRowItem="handleClickRowItemMixin"
			@onSetMarkedColor="handleSetMarkedColorMixin"
			@onClickCreateTodo="handleClickCreateTodoMixin"
			@onClickDuplicate="handleClickDuplicateRequest"
			@onClickCancelMenu="handleClickCancelRequestMixin"
			@onClickRecreateMenu="handleClickRecreateRequestMenuMixin"
			@onClickApproveOrRejectConfirm="handleClickApproveOrRejectMixin"
		/>

		<cbs-pagination class="mt-3" :total="totalPages" v-model="currentPage" v-if="requestsMixin && requestsMixin.length" />

		<request-form-dialog
			v-if="isShowRequestFormDialogMixin"
			v-model="activeRequestMixin"
			:stepsData="stepsDataMixin"
			:activeStepId="activeStepIdMixin"
			:requestTypes="requestTypesMixin"
			:isDialogActive="isShowRequestFormDialogMixin"
			:key="activeRequestMixin && activeRequestMixin.id ? activeRequestMixin.id : 'default'"
			@onClickExportData="handleExportDataMixin"
			@closeDialog="toggleRequestFormDialogMixin"
			@onClickStepItem="handleClickStepItemMixin"
			@onClickCreateTodo="handleClickCreateTodoMixin"
			@onClickDuplicate="handleClickDuplicateRequest"
			@onChangeRequestType="handleChangeRequestTypeMixin"
			@onDialogClose="handleSetInitRequestFormDialogMixin"
			@onIsFormDirtyChange="handleChangeIsRequestFormDirty"
			@onClickCancelRequest="handleClickCancelRequestMixin"
			@onClickSubmit="handleClickSubmitRequestFormDialogMixin"
			@onClickRecreateRequest="handleClickRecreateRequestMixin"
			@onClickApproveOrReject="handleClickApproveOrRejectMixin"
		/>

		<request-approve-or-reject-confirm-dialog
			v-if="isShowApproveOrRejectDialogMixin"
			v-model="approveOrRejectDataMixin"
			:isAgree="approveOrRejectStatusMixin"
			:isDialogActive="isShowApproveOrRejectDialogMixin"
			@onClickCancel="toggleApproveOrRejectDialogMixin(false)"
			@onClickConfirm="handleClickConfirmApproveOrRejectDialogMixin"
		/>

		<request-cancel-confirm-dialog
			v-model="cancelRequestDataMixin"
			:isDialogActive="isShowCancelRequestDialogMixin"
			@onClickCancel="toggleCancelRequestDialogMixin(false)"
			@onClickConfirm="handleClickConfirmCancelRequestMixin"
		/>

		<todo-list-form-sidebar
			:data="todoFormDialogDataMixin"
			:categoryId="$constant.TODO_CATEGORY.NORMAL"
			:isSidebarActive="isShowCreateTodoDialogMixin"
			@closeSidebar="toggleCreateTodoFormDialogMixin"
			@onCreateOrUpdateSuccess="handleOnCreateTodoSuccessMixin"
		/>

		<request-approver-dialog
			v-if="isShowApproverDialogMixin"
			:isApprovable="true"
			:value="approverDialogDataMixin"
			:title="requestApproverDialogTitleMixin"
			:isDialogActive="isShowApproverDialogMixin"
			:isEditable="requestApproverDialogEditableMixin"
			:requestPurpose="approverDialogDataMixin.request_reason || null"
			:mappedAttachObj="requestApproverDialogMappedAttachsDataObjMixin"
			@closeDialog="toggleApproverDialogMixin"
			@cancelRequest="handleClickCancelRequestMixin"
			@onClickCreateTodo="handleClickCreateTodoMixin"
			@onClickDuplicate="handleClickDuplicateRequest"
			@handleClickEdit="handleShowRequestFormDialogMixin"
			@handleClickApproveOrReject="handleClickApproveOrRejectMixin"
		/>
	</div>
</template>

<script>
import requestGQL from "@/http/requests/request/request_v2_gql";
import requestBasicHandlers from "@/mixins/requestBasicHandlers.js";

import RequestTable from "@/components/cbs-request/RequestTable";
import RequestFormDialog from "@/components/cbs-request/RequestFormDialog";
import TodoListFormSidebar from "@/views/apps/cbs/todo-list/TodoListFormSidebar";
import RequestApproverDialog from "@/components/cbs-request/RequestApproverDialog";
import RequestCancelConfirmDialog from "@/components/cbs-request/RequestCancelConfirmDialog";
import RequestApproveOrRejectConfirmDialog from "@/components/cbs-request/RequestApproveOrRejectConfirmDialog";

export default {
	name: "ListRequests",
	mixins: [requestBasicHandlers],
	components: {
		RequestTable,
		RequestFormDialog,
		TodoListFormSidebar,
		RequestApproverDialog,
		RequestCancelConfirmDialog,
		RequestApproveOrRejectConfirmDialog
	},
	emits: {
		onIsRequestFormDirtyChange: {}
	},
	data() {
		return {
			limit: 5,
			currentPage: 1,
			totalRequests: null
		};
	},
	computed: {
		totalPages() {
			return Math.ceil(this.totalRequests / this.limit);
		}
	},
	watch: {
		currentPage() {
			this.getRequests();
		},
		isShowRequestFormDialogMixin() {
			if (!this.isShowRequestFormDialogMixin) {
				this.handleChangeIsRequestFormDirty(false);
			}
		}
	},
	methods: {
		async getRequests() {
			try {
				this.$vs.loading();

				const queryOptions = {
					can_edit: true,
					limit: this.limit,
					page: this.currentPage,
					waiting_approval: true
				};

				if (this.searchText) {
					queryOptions.search = this.searchText;
				}

				// Fetch requestList
				const response = await requestGQL.getRequests(queryOptions);
				this.totalRequests = response.total;
				this.requestsMixin = response.data || [];
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		handleChangeIsRequestFormDirty(isRequestFormDirty) {
			this.$emit("onIsRequestFormDirtyChange", isRequestFormDirty);
		},
		async handleClickDuplicateRequest(requestId) {
			await this.handleClickDuplicateRequestMixin(requestId);
			this.getRequests();
		}
	},
	mounted() {
		this.getRequests();
	}
};
</script>
